/* Banner superior de Venta: novedades que pasan solas (scroll-snap + autoplay).
   Se frena al pasar el mouse, al tocar y cuando la pestaña está en segundo plano. */
(function(){
  const root = document.querySelector("[data-vb]");
  if(!root) return;
  const track = root.querySelector("[data-vb-track]");
  const slides = Array.from(track.children);
  const dotsEl = root.querySelector("[data-vb-dots]");
  let idx = 0, timer = null, touching = false;

  dotsEl.innerHTML = slides.map((_, i) => `<button type="button" aria-label="Ir al banner ${i + 1}"></button>`).join("");
  const dots = Array.from(dotsEl.children);
  const mark = () => dots.forEach((d, i) => d.classList.toggle("on", i === idx));
  const go = i => {
    idx = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[idx].offsetLeft, behavior: "smooth" });
    mark();
  };
  const start = () => {
    clearInterval(timer);
    timer = setInterval(() => {
      if(document.hidden || touching || root.matches(":hover")) return;
      go(idx + 1);
    }, 5000);
  };

  root.querySelector("[data-vb-prev]").addEventListener("click", () => { go(idx - 1); start(); });
  root.querySelector("[data-vb-next]").addEventListener("click", () => { go(idx + 1); start(); });
  dots.forEach((d, i) => d.addEventListener("click", () => { go(i); start(); }));

  let t;
  track.addEventListener("scroll", () => {
    clearTimeout(t);
    t = setTimeout(() => {
      const w = track.clientWidth || 1;
      idx = Math.round(track.scrollLeft / w);
      mark();
    }, 60);
  });
  track.addEventListener("touchstart", () => { touching = true; }, { passive:true });
  track.addEventListener("touchend", () => { touching = false; start(); }, { passive:true });

  mark();
  start();
})();
